import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const testimonials = [
  {
    img: "/img/profiles/avatar-01.jpg",
    text: "SRS Cab Service made my trip in Delhi so comfortable and hassle-free!",
    name: "Mr. Rajesh Kumar",
    location: "Delhi, India",
  },
  {
    img: "/img/profiles/avatar-02.jpg",
    text: "Their drivers are punctual, friendly, and the cars are very clean.",
    name: "Miss Priya Sharma",
    location: "Mumbai, India",
  },
  {
    img: "/img/profiles/avatar-03.jpg",
    text: "Affordable fares and quick booking process. Highly recommend SRS Cabs!",
    name: "Mr. Anil Singh",
    location: "Bangalore, India",
  },
  {
    img: "/img/profiles/avatar-04.jpg",
    text: "We had a wonderful journey with SRS Cab. Safe and reliable service.",
    name: "Miss Neha Gupta",
    location: "Chennai, India",
  },
];

const TestimonialSlider = () => {
  return (
    <section className="testimonial-section">
      <div className="container">
        <div className="section-heading heading-four">
          <h2>Our Clients Feedback</h2>
          <p>
            Hear what our customers have to say about their rides with SRS Cab Service.
          </p>
        </div>

        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 3000 }}
          spaceBetween={20}
          slidesPerView={3}
          loop={true}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-item testimonial-item-two">
                <div className="user-img">
                  {/* <img src={item.img} className="img-fluid" alt={item.name} /> */}
                </div>

                <p>{item.text}</p>

                <div className="rating">
                  <i className="fas fa-star filled"></i>
                  <i className="fas fa-star filled"></i>
                  <i className="fas fa-star filled"></i>
                  <i className="fas fa-star filled"></i>
                  <i className="fas fa-star filled"></i>
                </div>

                <div className="user-info">
                  <h6>{item.name}</h6>
                  <p>{item.location}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSlider;